import { Component, Inject, OnInit } from '@angular/core';
import { AbstractControl, FormBuilder, FormControl, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA as MAT_DIALOG_DATA, MatDialog as MatDialog, MatDialogRef as MatDialogRef } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { Observable, catchError, forkJoin, tap, throwError, of } from 'rxjs';
import { Control } from 'src/models/control';
import { User } from 'src/models/user';
import { APICustomerBasicDataService } from 'src/services/api-services/api-customer-basic-data-service';
import { APIDocumentTypeService } from 'src/services/api-services/api-document-type.service';
import { VehicleRelationship } from 'src/services/api-services/api-interfaces/vehicleRelationship.interface';
import { APIVehicleRelationship } from 'src/services/api-services/api-vehicle-relationship.service';
import { HelperService } from 'src/services/helperService';
import { ClientsComponent } from '../../clients.component';
import { VehicleData, VehicleDataClients } from 'src/services/api-services/api-interfaces/vehicleData.interface';
import { CustomerBasicDataEdit } from 'src/services/api-services/api-interfaces/customerBasicData.interface';
import { APIBrandsService } from 'src/services/api-services/api-brands-service';
import { VehicleDataService } from 'src/services/api-services/vehicleData-service';

const noSpecialCharsValidator = (control: AbstractControl): {[key: string]: any} | null => {
  const noSpecialChars = /^[^*=,\/#!$%\^\*;:{}\[\]~()<>\?|]+$/;
  const forbidden = !noSpecialChars.test(control.value);
  return forbidden ? {'noSpecialChars': {value: control.value}} : null;
};

const emailValidator = (control: AbstractControl): {[key: string]: any} | null => {
  const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
  const forbidden = !emailPattern.test(control.value);
  return forbidden ? {'invalidEmail': {value: control.value}} : null;
};

@Component({
    selector: 'app-edition-clients',
    templateUrl: './edition-clients.component.html',
    styleUrls: ['./edition-clients.component.sass'],
    standalone: false
})

export class EditionClientsComponent implements OnInit {


  onAddControlClick = (param: string): void => {};
  vehicleData!:VehicleDataClients[]
  constructor(
    @Inject(MAT_DIALOG_DATA) 
    public client: CustomerBasicDataEdit,
    private fb: FormBuilder, 
    public dialog: MatDialog,
    private translate: TranslateService, 
    public helperService: HelperService,
    public APIServicetypeDocument: APIDocumentTypeService,
    public VehicleRelationshipService: APIVehicleRelationship,
    public customerBasicDataService: APICustomerBasicDataService,
    public brandsService: APIBrandsService,
    public vehicleDataService: VehicleDataService,
    public dialogRef: MatDialogRef<ClientsComponent>
  ) { }

  isLoadingSave:boolean = true;
  user:User= this.helperService.user
  id=  this.user.countryId
  documentType$: Observable<DocumentType[]> =  new Observable<DocumentType[]>();
  relationchip$: Observable<VehicleRelationship[]> =  new Observable<VehicleRelationship[]>();
  graphDropdowns$: Observable<any[]> =  new Observable<any[]>();
  VehicleForCustomerId$: Observable<VehicleDataClients[]> =  new Observable<VehicleDataClients[]>();
  personTypes: any[] = [];
  documentTypesByPersonType: any[] = [];
  vehicleBrands: any[] = [];
  vehicleBrandOptionsByRow: any[][] = [];
  vehicleModelsByRow: any[][] = [];
  vehicleModelOptionsByRow: any[][] = [];
  selectedVehicleBrandIdByRow: Array<number | null> = [];
  vehicleBrandInvalidByRow: boolean[] = [];
  vehicleModelInvalidByRow: boolean[] = [];

  controls: Control[] = [
    {
      icon: 'bi bi-plus-lg',
      description: 'Add Workshops',
      action: this.onAddControlClick,
    },
  ];

  ngOnInit(): void {
    this.watchPersonTypeChanges();
    this.dataLoading()
    this.loadVehicleBrands();
    //  console.log(this.client)
  }

  dataLoading(){
    const savedPersonTypeId = Number(this.client.PersonTypeId);
    const savedDocumentType = Number(this.client.DocumentType);
    this.EditClientForm.patchValue({
      FirstName : String(this.client.FirstName),
      LastName: String(this.client.LastName),
      email: String(this.client.Email),
      tipoDePersona: savedPersonTypeId,
      typeDoc: Number(this.client.DocumentType),
      NumDoc: String(this.client.Identification),
      Phone: String(this.client.Phone),
      Address: String(this.client.Address),
      SapCoustomerID:String(this.client.SapCustomerId),
      OwnerRelation: Number(this.client.Vehicles[0].RelationshipVehicleId)
    })

    this.loadPersonTypes();
    this.loadDocumentTypesByPersonType(savedPersonTypeId, savedDocumentType);

    this.graphDropdowns$ = forkJoin([
      this.documentType$=  this.APIServicetypeDocument.GetByCountryId(this.id)
      .pipe(
        catchError((error: any) => {
          // Validation 401 error
          if(error.status === 401){
            this.helperService.logoutToken()
          }

          // Handle validation error here
          console.error('Validation Error:', error);
          // Rethrow the error to propagate it downstream
          return throwError(() => error);
        })
      ),
      this.relationchip$= this.VehicleRelationshipService.getAllVehicleRelationships(),
      this.VehicleForCustomerId$ = this.customerBasicDataService
          .getForIdCustomerVehicle(this.client.CustomerId)
          .pipe(
            tap((response) => {
              this.vehicleData = response;
              this.initializeVehicleAutocompleteRows();
            })
          )
    ]);
  }
  //Propiedades del vehículo
  createVehicle() {
    this.vehicleData.push({
      VehicleId:0,
      Plate:"",
      VIN:"",
      ModelDescription:"",
      Brand:"",
      Mileage:""})
      const index = this.vehicleData.length - 1;
      this.vehicleBrandOptionsByRow[index] = [...this.vehicleBrands];
      this.vehicleModelsByRow[index] = [];
      this.vehicleModelOptionsByRow[index] = [];
      this.selectedVehicleBrandIdByRow[index] = null;
      this.vehicleBrandInvalidByRow[index] = false;
      this.vehicleModelInvalidByRow[index] = false;
  }

  formsValidations(): boolean {
    if (this.hasInvalidVehicleBrandOrModel()) {
      return true;
    }
    let is_true = true;
    if(this.vehicleData){
    this.vehicleData.forEach(vehicle=>{
      if(vehicle.Plate !== ''){is_true = false}
      else{is_true = true}
      if(vehicle.VIN !== ''){is_true = false}
      else{is_true = true}
      if(vehicle.Mileage !== ''){is_true = false}
      else{is_true = true}
    })}
    if(!is_true){
    const isFormValidationInvalid = this.EditClientForm!.invalid
    return isFormValidationInvalid
  }else{return true; }

  }

  onSaveCreateclient(){
    this.isLoadingSave=false
      let clientJson ={
        CustomerId:this.client.CustomerId,
        SapCustomerId: this.EditClientForm.value.SapCoustomerID,
        Identification: this.EditClientForm.value.NumDoc,
        PersonTypeId: this.EditClientForm.value.tipoDePersona,
        DocumentType: this.EditClientForm.value.typeDoc,
        FirstName: this.EditClientForm.value.FirstName,
        LastName: this.EditClientForm.value.LastName,
        Email: this.EditClientForm.value.email,
        Phone: this.EditClientForm.value.Phone,
        Address:this.EditClientForm.value.Address,
        RelationshipVehicleId: this.EditClientForm.value.OwnerRelation,
        Vehicles: this.vehicleData
    }
  this.customerBasicDataService.postCreateCustomer(clientJson).pipe(
    tap((response)=>{
      // console.log(response)
      if(response.message=== "Customer Created Successfully"){
        const translateTextSuccess = this.translate.instant("ToastUpdateClient",{User:String(this.EditClientForm.value.FirstName)+ " " + String(this.EditClientForm.value.LastName)});

            this.helperService.showAlert =true
            this.helperService.typeAlert ="success"
            this.helperService.messageAlert =translateTextSuccess

            setTimeout(() => {
              this.helperService.showAlert =false

              }, 7000)

        this.isLoadingSave=true
        this.dialogRef.close("refreshCustomer");

      }
    }),
  ).subscribe(
    {
      error: (failed) => {
        // Validation 401 error
        if(failed.status === 401){
          this.helperService.logoutToken()
        }

        const errorMessage = failed.error
        let translateTextError = ''


        if (errorMessage.includes("The identification already exists for another customer")){
          translateTextError = this.translate.instant("ToastErrorUpdateClientExists",{Identification:String(this.EditClientForm.value.NumDoc)});
        } else{
          translateTextError = this.translate.instant("ToastErrorUpdateClient");
        }

        this.helperService.showAlert =true
        this.helperService.typeAlert ="error"
        this.helperService.messageAlert = translateTextError

        setTimeout(() => {
          this.helperService.showAlert =false

          }, 7000)
        this.dialogRef.close();

      },
    }
  )
  }

  EditClientForm = this.fb.group({
    FirstName:["", [ Validators.required,noSpecialCharsValidator ]],
    LastName:["", [ Validators.required,noSpecialCharsValidator ]],
    email:["", [ Validators.required,emailValidator,noSpecialCharsValidator  ]],
    tipoDePersona:[0, [ Validators.required ]],
    typeDoc:[0, [ Validators.required]],
    NumDoc:["", [ Validators.required,noSpecialCharsValidator  ]],
    Phone:["", [ Validators.required,noSpecialCharsValidator  ]],
    Address:[""],
    SapCoustomerID:[""],
    OwnerRelation:[0,[ Validators.required ]]
  })

  get correoControl(): FormControl {
    return this.EditClientForm.get('email') as FormControl;
  }

  get tipoDePersona(): FormControl {
    return this.EditClientForm.get('tipoDePersona') as FormControl;
  }

  private loadPersonTypes(): void {
    this.APIServicetypeDocument.GetPersonTypeByCountryId(this.id)
      .pipe(
        catchError((error: any) => {
          if (error.status === 401) {
            this.helperService.logoutToken();
          }

          console.error('Error loading person types:', error);
          return of([]);
        })
      )
      .subscribe((personTypes: any[]) => {
        this.personTypes = personTypes ?? [];
      });
  }

  private loadDocumentTypesByPersonType(
    personTypeId: number | null | undefined,
    selectedDocumentType?: number
  ): void {
    if (!personTypeId) {
      this.documentTypesByPersonType = [];
      this.EditClientForm.get('typeDoc')?.reset(null);
      return;
    }

    this.APIServicetypeDocument
      .GetDocumentTypeByCountryIdByPersonId(
        this.helperService.user.countryId,
        Number(personTypeId)
      )
      .pipe(
        catchError((error: any) => {
          if (error.status === 401) {
            this.helperService.logoutToken();
          }

          console.error('Error loading document types:', error);
          this.documentTypesByPersonType = [];
          return of([]);
        })
      )
      .subscribe((docs: any[]) => {
        this.documentTypesByPersonType = docs ?? [];

        const currentDoc = selectedDocumentType ?? this.EditClientForm.get('typeDoc')?.value;

        const stillValid = this.documentTypesByPersonType.some(
          d => Number(d.typeId) === Number(currentDoc)
        );

        if (stillValid) {
          this.EditClientForm.get('typeDoc')?.setValue(Number(currentDoc), { emitEvent: false });
        } else {
          this.EditClientForm.get('typeDoc')?.reset(null);
        }
      });
  }

  private watchPersonTypeChanges(): void {
    this.EditClientForm.get('tipoDePersona')?.valueChanges.subscribe((personTypeId) => {
      this.loadDocumentTypesByPersonType(personTypeId);
    });
  }

  private loadVehicleBrands(): void {
    this.brandsService.getBrandsByCountryId(this.id)
      .pipe(
        catchError((error: any) => {
          if (error.status === 401) {
            this.helperService.logoutToken();
          }
          console.error('Error loading vehicle brands:', error);
          return of([]);
        })
      )
      .subscribe((brands: any[]) => {
        this.vehicleBrands = brands ?? [];
        this.initializeVehicleAutocompleteRows();
      });
  }

  private initializeVehicleAutocompleteRows(): void {
    if (!this.vehicleData || !this.vehicleBrands.length) {
      return;
    }
    this.vehicleData.forEach((vehicle, index) => {
      this.vehicleBrandOptionsByRow[index] = [...this.vehicleBrands];
      this.vehicleModelsByRow[index] = this.vehicleModelsByRow[index] ?? [];
      this.vehicleModelOptionsByRow[index] = this.vehicleModelOptionsByRow[index] ?? [];
      this.vehicleBrandInvalidByRow[index] = false;
      this.vehicleModelInvalidByRow[index] = false;
      const brand = this.findBrandByName(vehicle.Brand);
      if (!brand) {
        this.selectedVehicleBrandIdByRow[index] = null;
        this.vehicleBrandInvalidByRow[index] = !!vehicle.Brand;
        return;
      }
      this.vehicleData[index].Brand = brand.brandName;
      this.selectedVehicleBrandIdByRow[index] = brand.brandId;
      this.vehicleBrandInvalidByRow[index] = false;
      this.loadVehicleModelsByBrand(index, brand.brandId, vehicle.ModelDescription);
    });
  }

  filterVehicleBrands(index: number, value: string | any): void {
    const filterValue = typeof value === 'string'
      ? value.toLowerCase()
      : value?.brandName?.toLowerCase() ?? '';
    this.vehicleBrandOptionsByRow[index] = this.vehicleBrands.filter(brand =>
      brand.brandName.toLowerCase().includes(filterValue)
    );
  }

  getBrandName(brand: any): string {
    if (typeof brand === 'string') {
      return brand;
    }
    return brand?.brandName ?? '';
  }

  onVehicleBrandInputChange(index: number, value: string | any): void {
    if (typeof value !== 'string') {
      return;
    }
    this.vehicleData[index].Brand = value;
    this.vehicleData[index].ModelDescription = '';
    this.selectedVehicleBrandIdByRow[index] = null;
    this.vehicleBrandInvalidByRow[index] = false;
    this.vehicleModelInvalidByRow[index] = false;
    this.vehicleModelsByRow[index] = [];
    this.vehicleModelOptionsByRow[index] = [];
    this.filterVehicleBrands(index, value);
  }

  onVehicleBrandSelected(index: number, brand: any): void {
    this.vehicleData[index].Brand = brand.brandName;
    this.vehicleData[index].ModelDescription = '';
    this.selectedVehicleBrandIdByRow[index] = brand.brandId;
    this.vehicleBrandInvalidByRow[index] = false;
    this.vehicleModelInvalidByRow[index] = false;
    this.vehicleModelsByRow[index] = [];
    this.vehicleModelOptionsByRow[index] = [];
    this.loadVehicleModelsByBrand(index, brand.brandId);
  }

  private loadVehicleModelsByBrand(index: number, brandId: number, selectedModelDescription?: string): void {
    if (!brandId) {
      this.vehicleModelsByRow[index] = [];
      this.vehicleModelOptionsByRow[index] = [];
      return;
    }
    const plate = this.vehicleData[index]?.Plate
      ? String(this.vehicleData[index].Plate).toUpperCase()
      : '';
    this.vehicleDataService
      .getValidatedDataWithCountryAndbrand(plate, brandId)
      .pipe(
        catchError((error: any) => {
          if (error.status === 401) {
            this.helperService.logoutToken();
          }
          console.error('Error loading vehicle models:', error);
          this.vehicleModelsByRow[index] = [];
          this.vehicleModelOptionsByRow[index] = [];
          return of(null);
        })
      )
      .subscribe((customer: any) => {
        const models = customer?.vehicleModelInfo?.models ?? [];
        this.vehicleModelsByRow[index] = models;
        this.vehicleModelOptionsByRow[index] = models;
        if (selectedModelDescription) {
          const model = this.findModelByName(index, selectedModelDescription);
          if (model) {
            this.vehicleData[index].ModelDescription = model;
            this.vehicleModelInvalidByRow[index] = false;
          } else {
            this.vehicleModelInvalidByRow[index] = true;
          }
        }
      });
  }

  filterVehicleModels(index: number, value: string): void {
    const filterValue = (value ?? '').toLowerCase();
    this.vehicleModelOptionsByRow[index] = (this.vehicleModelsByRow[index] ?? []).filter(model =>
      String(model).toLowerCase().includes(filterValue)
    );
  }

  onVehicleModelSelected(index: number, model: string): void {
    this.vehicleData[index].ModelDescription = model;
    this.vehicleModelInvalidByRow[index] = false;
  }

  private normalizeVehicleText(value: any): string {
    return String(value ?? '').trim().toLowerCase();
  }

  private findBrandByName(brandName: string | null | undefined): any {
    const normalizedBrandName = this.normalizeVehicleText(brandName);
    return this.vehicleBrands.find(brand =>
      this.normalizeVehicleText(brand.brandName) === normalizedBrandName
    );
  }

  private findModelByName(index: number, modelName: string | null | undefined): string | undefined {
    const normalizedModelName = this.normalizeVehicleText(modelName);
    return (this.vehicleModelsByRow[index] ?? []).find(model =>
      this.normalizeVehicleText(model) === normalizedModelName
    );
  }

  validateVehicleBrand(index: number): void {
    const brandName = this.vehicleData[index]?.Brand;
    if (!brandName) {
      this.vehicleBrandInvalidByRow[index] = false;
      this.selectedVehicleBrandIdByRow[index] = null;
      return;
    }
    const brand = this.findBrandByName(brandName);
    if (!brand) {
      this.vehicleBrandInvalidByRow[index] = true;
      this.selectedVehicleBrandIdByRow[index] = null;
      this.vehicleData[index].ModelDescription = '';
      this.vehicleModelsByRow[index] = [];
      this.vehicleModelOptionsByRow[index] = [];
      return;
    }
    this.vehicleData[index].Brand = brand.brandName;
    this.vehicleBrandInvalidByRow[index] = false;
    if (this.selectedVehicleBrandIdByRow[index] !== brand.brandId) {
      this.selectedVehicleBrandIdByRow[index] = brand.brandId;
      this.vehicleData[index].ModelDescription = '';
      this.vehicleModelInvalidByRow[index] = false;
      this.loadVehicleModelsByBrand(index, brand.brandId);
    }
  }

  validateVehicleModel(index: number): void {
    const modelName = this.vehicleData[index]?.ModelDescription;
    if (!modelName) {
      this.vehicleModelInvalidByRow[index] = false;
      return;
    }
    const model = this.findModelByName(index, modelName);
    if (!model) {
      this.vehicleModelInvalidByRow[index] = true;
      return;
    }
    this.vehicleData[index].ModelDescription = model;
    this.vehicleModelInvalidByRow[index] = false;
  }

  hasInvalidVehicleBrandOrModel(): boolean {
    return this.vehicleData?.some((vehicle, index) => {
      const brandName = vehicle?.Brand;
      const modelName = vehicle?.ModelDescription;
      const brandInvalid = !!brandName && !this.findBrandByName(brandName);
      const modelInvalid = !!modelName && !this.findModelByName(index, modelName);
      return brandInvalid ||
        modelInvalid ||
        this.vehicleBrandInvalidByRow[index] ||
        this.vehicleModelInvalidByRow[index];
    }) ?? false;
  }

}
